// EXT:form renders IDs as {formIdentifier}-{fieldIdentifier}
const aktionsInput = document.querySelector<HTMLInputElement>('[id$="-aktionscode"]');
const praemienSelect = document.querySelector<HTMLSelectElement>('[id$="-praemiencode"]');
const laufzeitRadios = document.querySelectorAll<HTMLInputElement>('input[id*="-laufzeit"]');
const tarifRadios = document.querySelectorAll<HTMLInputElement>('input[id*="-tarif"]');
const bezugsbedingungenEl = document.querySelector<HTMLElement>('[id$="-bezugsbedingungen"]');
const agbLabel = document.querySelector<HTMLElement>('[id$="-agb"] ~ label, label[for$="-agb"]');

// Disable browser validation so TYPO3 server-side validation handles all fields
aktionsInput?.closest('form')?.setAttribute('novalidate', 'novalidate');

const WIDERRUF_TEXT = ' <span class="widerruf-text">Ich stimme ausdrücklich zu, dass IDEA vor Ablauf der Widerrufsfrist mit der Ausführung des Vertrags beginnt. Mir ist bekannt, dass ich durch diese Zustimmung mein Widerrufsrecht verliere.</span>';
let agbBaseText = agbLabel?.innerHTML ?? '';

const updateAgbLabel = (widerruf: number): void => {
  if (!agbLabel) return;
  agbLabel.innerHTML = widerruf === 1 ? agbBaseText + WIDERRUF_TEXT : agbBaseText;
};

let rawBezugsbedingungen = '';

const BEZUG_PLACEHOLDER = '<p>Bitte wählen Sie Tarif, Laufzeit und Prämie aus, um die passenden Bezugsbedingungen anzuzeigen.</p>';
if (bezugsbedingungenEl) bezugsbedingungenEl.innerHTML = BEZUG_PLACEHOLDER;

const renderBezugsbedingungen = (): void => {
  if (!bezugsbedingungenEl || !rawBezugsbedingungen) return;

  const laufzeit = Array.from(laufzeitRadios).find((r) => r.checked)?.value ?? '';
  const praemieName = praemienSelect?.options[praemienSelect.selectedIndex]?.text ?? '';
  const praemieValue = praemienSelect?.value ?? '';
  const tarifChecked = Array.from(tarifRadios).some((r) => r.checked);

  if (!tarifChecked || !laufzeit || !praemieValue) {
    bezugsbedingungenEl.innerHTML = BEZUG_PLACEHOLDER;
    return;
  }

  bezugsbedingungenEl.innerHTML = rawBezugsbedingungen
    .replace(/###LAUFZEIT###/g, laufzeit)
    .replace(/###PRÄMIE###/g, praemieName);
};

const updateBezugsbedingungen = async (tarifUid: string): Promise<void> => {
  if (!bezugsbedingungenEl) return;
  try {
    const response = await fetch(`/ideashop/ajax/bezugsbedingungen?tarif=${tarifUid}`);
    const data: { bezugsbedingungen: string; widerruf: number } = await response.json();
    rawBezugsbedingungen = data.bezugsbedingungen;
    updateAgbLabel(data.widerruf);
    renderBezugsbedingungen();
  } catch {
    // keep existing content on error
  }
};

const setPlaceholder = (text: string): void => {
  if (!praemienSelect) return;
  const first = praemienSelect.options[0];
  if (first) first.text = text;
};

const updatePraemien = async (): Promise<void> => {
  if (!praemienSelect || !aktionsInput) return;

  const laufzeit = Array.from(laufzeitRadios).find((r) => r.checked)?.value;
  const aktionsnummer = aktionsInput.value;

  if (!laufzeit || !aktionsnummer) {
    praemienSelect.innerHTML = '<option value="">Bitte wählen Sie zuerst die Laufzeit aus</option>';
    return;
  }

  try {
    const url = `/ideashop/ajax/praemien?laufzeit=${laufzeit}&aktion=${encodeURIComponent(aktionsnummer)}`;
    const response = await fetch(url);
    const data: Record<string, string> = await response.json();

    praemienSelect.innerHTML = '<option value="">Bitte wählen Sie eine Prämie aus</option>';
    renderBezugsbedingungen(); // reset to placeholder since praemie was cleared
    Object.entries(data).forEach(([uid, name]) => {
      const option = document.createElement('option');
      option.value = uid;
      option.textContent = name;
      praemienSelect.appendChild(option);
    });

    renderBezugsbedingungen();
  } catch (e) {
    console.error('[Prämien] fetch error:', e);
  }
};

if (laufzeitRadios.length > 0 && praemienSelect) {
  setPlaceholder('Bitte wählen Sie zuerst die Laufzeit aus');
  laufzeitRadios.forEach((radio) => radio.addEventListener('change', () => {
    updatePraemien(); // renderBezugsbedingungen is called inside after fetch
  }));
}

if (tarifRadios.length > 0 && bezugsbedingungenEl) {
  tarifRadios.forEach((radio) => {
    radio.addEventListener('change', () => updateBezugsbedingungen(radio.value));
  });
}

if (praemienSelect) {
  praemienSelect.addEventListener('change', renderBezugsbedingungen);
}

// On reload after validation errors: restore praemien select if tarif and laufzeit are already set
const preselectedLaufzeit = Array.from(laufzeitRadios).find((r) => r.checked)?.value;
const preselectedTarif = Array.from(tarifRadios).find((r) => r.checked)?.value;
if (preselectedLaufzeit && preselectedTarif) {
  updatePraemien();
  updateBezugsbedingungen(preselectedTarif);
}

